export const DND_ITEM_TYPES = {
    MACHINES: 'MACHINES',
    DAILYSUPPLIES: 'DAILYSUPPLIES',
    RENTALS: 'RENTALS',
    SUBCONTRACTORS: 'SUBCONTRACTORS',
    TEMPWORKERS: 'TEMPWORKERS',
    TOOLS: 'TOOLS',
    TRANSFERSPLANNED: 'TRANSFERSPLANNED',
    TRUCKSPLANNED: 'TRUCKSPLANNED',
    
};
